import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import PlanListing from '../components/PlanListing';
import ModularBlocks from '../components/ModularBlocks';
import NewsletterSignup from '../components/NewsletterSignup';

const PlanListingPageTemplate = ({
  data: {
    contentfulPlans: {
      title,
      metaDescription,
      bannerHeading,
      bannerText,
      plans,
      modularBlocks,
    },
  },
  location,
}) => (
  <Layout
    seo={{
      title: title,
      metaDescription: metaDescription,
      location: location,
    }}
  >
    <main>
      <PlanListing
        heading={bannerHeading || title}
        text={bannerText}
        items={plans}
      />
      <ModularBlocks items={modularBlocks} />
      <NewsletterSignup />
    </main>
  </Layout>
);

export const PlanListingPageTemplateQuery = graphql`
  query PlanListingPageTemplateQuery {
    contentfulPlans {
      title
      metaDescription
      bannerHeading
      bannerText
      plans {
        ...PlanCardFragment
      }
      modularBlocks {
        ...AccordionModularBlockFragment
        ...CompetitorComparisonModularBlockFragment
        ...CustomerReviewsModularBlockFragment
        ...FeaturedLogosModularBlockFragment
        ...LatestCommunityStoriesModularBlockFragment
        ...VideoContentBannerModularBlockFragment
      }
    }
  }
`;

export default PlanListingPageTemplate;
